<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "App",
  setup() {},
});
</script>

<style lang="scss">
@import "sweetalert2/dist/sweetalert2.css";
@import "element-plus/dist/index.css";
@import "/public/fe/logistic/css/custom.css";

</style>


